// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  /* Cover Photo */
  .cover-container {
    position: relative;
    width: 96%;
    height: 350px;
    background-color: #080808;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    overflow: hidden; /* Prevent overflow */
    gap:2px;
  }

  .base-container img {
    max-width: 100%;
    max-height: 100%;
    height: auto;
    width: 1300px;
}

.profile-photo {
  position: absolute;
  bottom: -30px;
  left: 20px;
  width: 100px;
  height: 110px;
  background-color: gray;
  border-radius: 50%;
  border: 3px solid #fff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  margin-left:10px;
  margin-bottom: 30px;
  }

.profile-title {
  position: absolute;
  bottom: 5%; /* Align with the bottom of the header */
  right: -360px; /* Offset from the right */
  font-size: 18px; /* Adjust font size as needed */
  font-weight: bold;
  font-style: italic; /* Italic font */
  background: grey; /* Multi-colored gradient */
 /* background: linear-gradient(90deg, #ff8661,rgb(211, 17, 17), #23ae64, #b9d100); /* Multi-colored gradient */
  -webkit-background-clip: text; /* Clip gradient to text */
  -webkit-text-fill-color: transparent; /* Make the text transparent to show gradient */
  white-space: nowrap; /* Prevent text wrapping */
  text-align: right; /* Right-align text */ 
  } 

    /* Feed Navigation */
    .feed-navigation {
      display: flex;
      gap: 10px;
    }
    
    .feed-navigation button {
      background-color: #007bff;
      color: white;
      border: none;
      padding: 10px 15px;
      border-radius: 5px;
      cursor: pointer;
    }
    
    /* Main Feed */
    .main-feed {
      background-color: #fff;
      padding: 20px;
      border-radius: 10px;
      gap: 10px;
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
    }

    .uml-main-messaging-container {
      max-height: 800px;
      height: auto;
      overflow-y: scoll;
    }    
    /* Messages Container */
    .uac-message-display {
      overflow-y: auto;
      padding: 15px;
      display: flex;
      flex-direction: column;
      /* min-height: 73vh;
      max-height: 73vh; */
      height: 600px;
      width: 670px;
      overflow-y: scroll;
    }
    
    /* Date Separator */
    .uac-date-separator {
      text-align: center;
      font-size: 14px;
      color: gray;
      margin: 10px 0;
    }
    
    /* Message Bubbles */
    .message-bubble {
      max-width: 60%;
      padding: 10px;
      margin: 5px 0;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      font-size: 14px;
    }
    
    .sent {
      background-color: #dcf8c6;
      align-self: flex-end;
    }
    
    .received {
      background-color: #ffffff;
      align-self: flex-start;
    }
    
    /* Message Timestamp */
    .message-time {
      font-size: 10px;
      color: gray;
      text-align: right;
    }
    
    .um-message-input input {
      flex: 1 1;
      padding: 10px;
      border: 1px solid #ddd;
      border-radius: 20px;
      outline: none;
      font-size: 14px;
    }
    
    .icon-button {
      background: none;
      border: none;
      cursor: pointer;
      margin: 0 10px;
      color: #888;
    }
    
    .icon-button:hover {
      color: #555;
    }
    
    .send-button {
      background: #007bff;
      color: #fff;
      padding: 8px 15px;
      border: none;
      border-radius: 20px;
      cursor: pointer;
    }
    
    .send-button:hover {
      background: #0056b3;
    }
    
  /* Responsive Design */
  @media (max-width: 900px) {
    .page-grid {
      grid-template-areas:
        "top"
        "middle"
        "left"
        "right";
      grid-template-columns: 1fr;
      grid-template-rows: 80px auto auto auto;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/common/Messaging/Styles/UMGridCentreLayout.css"],"names":[],"mappings":"EAAE,gBAAgB;EAChB;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB,EAAE,qBAAqB;IACvC,OAAO;EACT;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB;;AAEF;EACE,kBAAkB;EAClB,UAAU,EAAE,wCAAwC;EACpD,aAAa,EAAE,0BAA0B;EACzC,eAAe,EAAE,+BAA+B;EAChD,iBAAiB;EACjB,kBAAkB,EAAE,gBAAgB;EACpC,gBAAgB,EAAE,2BAA2B;CAC9C,8GAA8G;EAC7G,6BAA6B,EAAE,0BAA0B;EACzD,oCAAoC,EAAE,+CAA+C;EACrF,mBAAmB,EAAE,0BAA0B;EAC/C,iBAAiB,EAAE,qBAAqB;EACxC;;IAEE,oBAAoB;IACpB;MACE,aAAa;MACb,SAAS;IACX;;IAEA;MACE,yBAAyB;MACzB,YAAY;MACZ,YAAY;MACZ,kBAAkB;MAClB,kBAAkB;MAClB,eAAe;IACjB;;IAEA,cAAc;IACd;MACE,sBAAsB;MACtB,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,2CAA2C;IAC7C;;IAEA;MACE,iBAAiB;MACjB,YAAY;MACZ,iBAAiB;IACnB;IACA,uBAAuB;IACvB;MACE,gBAAgB;MAChB,aAAa;MACb,aAAa;MACb,sBAAsB;MACtB;yBACmB;MACnB,aAAa;MACb,YAAY;MACZ,kBAAkB;IACpB;;IAEA,mBAAmB;IACnB;MACE,kBAAkB;MAClB,eAAe;MACf,WAAW;MACX,cAAc;IAChB;;IAEA,oBAAoB;IACpB;MACE,cAAc;MACd,aAAa;MACb,aAAa;MACb,mBAAmB;MACnB,aAAa;MACb,sBAAsB;MACtB,eAAe;IACjB;;IAEA;MACE,yBAAyB;MACzB,oBAAoB;IACtB;;IAEA;MACE,yBAAyB;MACzB,sBAAsB;IACxB;;IAEA,sBAAsB;IACtB;MACE,eAAe;MACf,WAAW;MACX,iBAAiB;IACnB;;IAEA;MACE,SAAO;MACP,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,aAAa;MACb,eAAe;IACjB;;IAEA;MACE,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,cAAc;MACd,WAAW;IACb;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,mBAAmB;MACnB,WAAW;MACX,iBAAiB;MACjB,YAAY;MACZ,mBAAmB;MACnB,eAAe;IACjB;;IAEA;MACE,mBAAmB;IACrB;;EAEF,sBAAsB;EACtB;IACE;MACE;;;;eAIS;MACT,0BAA0B;MAC1B,uCAAuC;IACzC;EACF","sourcesContent":["  /* Cover Photo */\n  .cover-container {\n    position: relative;\n    width: 96%;\n    height: 350px;\n    background-color: #080808;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10px;\n    overflow: hidden; /* Prevent overflow */\n    gap:2px;\n  }\n\n  .base-container img {\n    max-width: 100%;\n    max-height: 100%;\n    height: auto;\n    width: 1300px;\n}\n\n.profile-photo {\n  position: absolute;\n  bottom: -30px;\n  left: 20px;\n  width: 100px;\n  height: 110px;\n  background-color: gray;\n  border-radius: 50%;\n  border: 3px solid #fff;\n  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: bold;\n  margin-left:10px;\n  margin-bottom: 30px;\n  }\n\n.profile-title {\n  position: absolute;\n  bottom: 5%; /* Align with the bottom of the header */\n  right: -360px; /* Offset from the right */\n  font-size: 18px; /* Adjust font size as needed */\n  font-weight: bold;\n  font-style: italic; /* Italic font */\n  background: grey; /* Multi-colored gradient */\n /* background: linear-gradient(90deg, #ff8661,rgb(211, 17, 17), #23ae64, #b9d100); /* Multi-colored gradient */\n  -webkit-background-clip: text; /* Clip gradient to text */\n  -webkit-text-fill-color: transparent; /* Make the text transparent to show gradient */\n  white-space: nowrap; /* Prevent text wrapping */\n  text-align: right; /* Right-align text */ \n  } \n\n    /* Feed Navigation */\n    .feed-navigation {\n      display: flex;\n      gap: 10px;\n    }\n    \n    .feed-navigation button {\n      background-color: #007bff;\n      color: white;\n      border: none;\n      padding: 10px 15px;\n      border-radius: 5px;\n      cursor: pointer;\n    }\n    \n    /* Main Feed */\n    .main-feed {\n      background-color: #fff;\n      padding: 20px;\n      border-radius: 10px;\n      gap: 10px;\n      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);\n    }\n\n    .uml-main-messaging-container {\n      max-height: 800px;\n      height: auto;\n      overflow-y: scoll;\n    }    \n    /* Messages Container */\n    .uac-message-display {\n      overflow-y: auto;\n      padding: 15px;\n      display: flex;\n      flex-direction: column;\n      /* min-height: 73vh;\n      max-height: 73vh; */\n      height: 600px;\n      width: 670px;\n      overflow-y: scroll;\n    }\n    \n    /* Date Separator */\n    .uac-date-separator {\n      text-align: center;\n      font-size: 14px;\n      color: gray;\n      margin: 10px 0;\n    }\n    \n    /* Message Bubbles */\n    .message-bubble {\n      max-width: 60%;\n      padding: 10px;\n      margin: 5px 0;\n      border-radius: 10px;\n      display: flex;\n      flex-direction: column;\n      font-size: 14px;\n    }\n    \n    .sent {\n      background-color: #dcf8c6;\n      align-self: flex-end;\n    }\n    \n    .received {\n      background-color: #ffffff;\n      align-self: flex-start;\n    }\n    \n    /* Message Timestamp */\n    .message-time {\n      font-size: 10px;\n      color: gray;\n      text-align: right;\n    }\n    \n    .um-message-input input {\n      flex: 1;\n      padding: 10px;\n      border: 1px solid #ddd;\n      border-radius: 20px;\n      outline: none;\n      font-size: 14px;\n    }\n    \n    .icon-button {\n      background: none;\n      border: none;\n      cursor: pointer;\n      margin: 0 10px;\n      color: #888;\n    }\n    \n    .icon-button:hover {\n      color: #555;\n    }\n    \n    .send-button {\n      background: #007bff;\n      color: #fff;\n      padding: 8px 15px;\n      border: none;\n      border-radius: 20px;\n      cursor: pointer;\n    }\n    \n    .send-button:hover {\n      background: #0056b3;\n    }\n    \n  /* Responsive Design */\n  @media (max-width: 900px) {\n    .page-grid {\n      grid-template-areas:\n        \"top\"\n        \"middle\"\n        \"left\"\n        \"right\";\n      grid-template-columns: 1fr;\n      grid-template-rows: 80px auto auto auto;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
